const log = {
    invalid_type: 'Geçersiz günlük türü.',
    invalid_time_window: "`end_time`, `start_time`'dan sonra olmalıdır.",
};
export default Object.freeze(log);
